import { get } from 'lodash';

export default ({ color, misc }) => ({
  MainPageContent: {
    backgroundColor: get(color, 'background'),
    minHeight: 'calc(100vh - (60px))',
    marginTop: get(misc, 'headerHeight'),
  },
});



// WEBPACK FOOTER //
// ./src/layouts/Main/index.theme.js